module.exports = __webpack_public_path__ + "img/1F62E.65f90a1d.svg";